module.exports = __webpack_public_path__ + "media/images/salespartner/problem03-d2ce64de584b90306803549756fe5ab8.svg";